function formatDateLabel(value) {
    if (!value) {
        return null;
    }

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) {
        return value;
    }

    return new Intl.DateTimeFormat('ru-RU', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    }).format(date);
}

function mapSubscriptionStatus(subscription) {
    if (subscription?.is_active === false) {
        return 'Не активен';
    }

    const statusMap = {
        active: 'Активен',
        inactive: 'Не активен',
        expired: 'Истёк',
    };

    if (subscription?.status && statusMap[subscription.status]) {
        return statusMap[subscription.status];
    }

    if (subscription?.status) {
        return subscription.status;
    }

    return 'Активен';
}

export function mapSubscription(userInfo) {
    const subscription = userInfo?.subscription || {};
    const plan = subscription.plan || {};

    return {
        plan: {
            name: plan.name || '—',
            status: mapSubscriptionStatus(subscription),
            isBasePlan: Boolean(plan.is_base_plan),
            expires: subscription.expires_at_label
                || formatDateLabel(subscription.expires_at || subscription.end_at || subscription.paid_until)
                || '—',
        },
        stats: {
            transactions: {
                current: subscription.transaction_count ?? 0,
                total: plan.transactions_rate_per_month ?? 0,
            },
            flows: {
                current: Number(subscription.workflows_count ?? userInfo?.workflows_count ?? 0),
                limit: 'Без ограничений',
            },
        },
        payment: {
            card: subscription.payment_method || userInfo?.payment_method || '—',
        },
    };
}
